"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var getRecipientToken_1 = require("../../utils/getRecipientToken");
var normalizeString_1 = require("../../utils/normalizeString");
var TrackAndTalk = /** @class */ (function () {
    function TrackAndTalk(shipmentInformation, shipmentLogs) {
        // Shipment information assignment
        this.trunkrsNr = shipmentInformation.parcel.trunkrsNr;
        this.recipient = shipmentInformation.recipient;
        this.neighbour = shipmentInformation.neighbour;
        this.parcel = shipmentInformation.parcel;
        this.sender = shipmentInformation.sender;
        // Shipment Logs assignment
        this.shipmentLogs = shipmentLogs;
    }
    /**
     * Retrieves the shipment information and shipment log history for the specified Trunkrs number and postal code.
     * @param {string} trunkrsNr The Trunkrs number
     * @param {string} postalCode The postal code
     * @returns {Promise<TrackAndTalk>}
     */
    TrackAndTalk.setup = function (trunkrsNr, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, shipmentInformation, shipmentLogs;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            TrackAndTalk.getShipmentInformation(trunkrsNr, normalizeString_1.normalizeString(postalCode)),
                            TrackAndTalk.getShipmentLogs(trunkrsNr, normalizeString_1.normalizeString(postalCode)),
                        ])];
                    case 1:
                        _a = _b.sent(), shipmentInformation = _a[0], shipmentLogs = _a[1];
                        return [2 /*return*/, new TrackAndTalk(shipmentInformation, shipmentLogs)];
                }
            });
        });
    };
    /**
     * Retrieves the shipment log history for the specified Trunkrs number and postal code.
     * @param {string} trunkrsNr The Trunkrs number
     * @param {string} postalCode The postal code
     * @returns {Promise<IShipmentLog[]>}
     */
    TrackAndTalk.getShipmentLogs = function (trunkrsNr, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __1.Model.makeRequest("/communications/track-and-talk/" + trunkrsNr + "/" + normalizeString_1.normalizeString(postalCode) + "/shipment-logs", __1.METHOD.GET, {}, false, { Authorization: getRecipientToken_1.getRecipientToken(trunkrsNr, postalCode) })];
            });
        });
    };
    /**
     * Retrieves today's message for the Trunkrs number and the postal code and for a specified date.
     * @param {string} trunkrsNr The Trunkrs number
     * @param {string} postalCode The postal code
     * @param {string | Date} date The date to fetch the message for.
     * @returns {Promise<IDailyMessageResponse>}
     */
    TrackAndTalk.getTodaysMessage = function (trunkrsNr, postalCode, date) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __1.Model.makeRequest(
                    // tslint:disable-next-line:max-line-length
                    "/communications/track-and-talk/" + trunkrsNr + "/" + normalizeString_1.normalizeString(postalCode) + "/message", __1.METHOD.GET, {
                        date: moment_1.default(date).format('YYYY-MM-DD'),
                    }, false, { Authorization: getRecipientToken_1.getRecipientToken(trunkrsNr, postalCode) })];
            });
        });
    };
    /**
     * Retrieves the shipment information for the specified Trunkrs number and postal code.
     * @param {string} trunkrsNr The Trunkrs number
     * @param {string} postalCode The postal code
     * @returns {Promise<ITrackTraceInformation>}
     */
    TrackAndTalk.getShipmentInformation = function (trunkrsNr, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __1.Model.makeRequest("/communications/track-and-talk/" + trunkrsNr + "/" + normalizeString_1.normalizeString(postalCode) + "/shipment-information", __1.METHOD.GET, {}, false, { Authorization: getRecipientToken_1.getRecipientToken(trunkrsNr, postalCode) })];
            });
        });
    };
    TrackAndTalk.getShipmentHistory = function (trunkrsNr, postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __1.Model.makeRequest("/communications/track-and-talk/" + trunkrsNr + "/" + normalizeString_1.normalizeString(postalCode) + "/shipment-history", __1.METHOD.GET, {}, false, { Authorization: getRecipientToken_1.getRecipientToken(trunkrsNr, postalCode) })];
            });
        });
    };
    TrackAndTalk.login = function (trunkrsNr, postalCode) {
        return __1.Model.makeRequest("/communications/track-and-talk/" + trunkrsNr + "/" + normalizeString_1.normalizeString(postalCode) + "/login/", __1.METHOD.POST, {}, false, { Authorization: getRecipientToken_1.getRecipientToken(trunkrsNr, postalCode) });
    };
    TrackAndTalk.getPostalCode = function (trunkrsNr, token) {
        return __1.Model.makeRequest("/communications/functions/postal-code-for-legacy-token/" + token + "/" + trunkrsNr, __1.METHOD.GET, {}, false);
    };
    TrackAndTalk.getTrunkrsNr = function (barcode) {
        return __1.Model.makeRequest("/communications/get-trunkrs-nr-for-barcode/" + barcode, __1.METHOD.GET, {}, false);
    };
    /**
     * Subscribes a phone number to change notification for the current shipment.
     * @param {string} phoneNumber
     * @returns {Promise<ISMSSubscription>}
     */
    TrackAndTalk.prototype.subscribeToSMS = function (phoneNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __1.Model.makeRequest("/communications/track-and-talk/" + this.getTrunkrsNr + "/" + normalizeString_1.normalizeString(this.getRecipient.postalCode) + "/subscribe/sms", __1.METHOD.POST, { phoneNumber: phoneNumber }, false, {
                        Authorization: getRecipientToken_1.getRecipientToken(this.getTrunkrsNr, this.getRecipient.postalCode),
                    })];
            });
        });
    };
    Object.defineProperty(TrackAndTalk.prototype, "getParcel", {
        /**
         * The parcel information for the current shipment.
         * @returns {IParcelInformation}
         */
        get: function () {
            return this.parcel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackAndTalk.prototype, "getShipmentLogs", {
        /**
         * The shipment log history for the current shipment.
         * @returns {IShipmentLog[]}
         */
        get: function () {
            return this.shipmentLogs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackAndTalk.prototype, "getRecipient", {
        /**
         * The recipient information for the current shipment.
         * @returns {IDeliveryLocation}
         */
        get: function () {
            return this.recipient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackAndTalk.prototype, "getTrunkrsNr", {
        /**
         * The Trunkrs number for the current shipment.
         * @returns {string}
         */
        get: function () {
            return this.trunkrsNr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackAndTalk.prototype, "getNeighbour", {
        /**
         * The neighbour information for the current shipment if applicable.
         * @returns {IDeliveryLocation | undefined}
         */
        get: function () {
            return this.neighbour;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackAndTalk.prototype, "getSender", {
        /**
         * The sender information for the current shipment.
         * @returns {ISenderInformation}
         */
        get: function () {
            return this.sender;
        },
        enumerable: true,
        configurable: true
    });
    return TrackAndTalk;
}());
exports.TrackAndTalk = TrackAndTalk;
